@if (loadingContent) {
  <content-loading-list></content-loading-list>
}

@if (!loadingContent && quality) {

  <!-- Current band, exactly as the provider reports it (RF-27) — system alert -->
  <div class="alert" [ngClass]="bandAlertClass()" role="alert">
    <h5 class="alert-heading mt-0 mb-1">{{ 'channel.health.qualityTab.bandTitle' | translate }}: {{ bandLabel() }}</h5>
    <p class="mb-0">
      {{ bandText() }}
      @if (quality.quality.lastChangeAt) {
        <small class="d-block">
          {{ 'channel.health.qualityTab.bandSince' | translate: { date: (quality.quality.lastChangeAt | date: 'dd/MM/yyyy') } }}
        </small>
      }
    </p>
  </div>

  <!-- Delivery KPIs — 30 days (RF-28) — dashboard stat cards in the dashboard's own grid -->
  <div class="grid-cards mb-3">
    <card-graphic-small-legacy-component
      [label]="percentLabel(quality.kpis.deliveryRate)"
      [total]="('channel.health.qualityTab.kpiDelivery' | translate) + ' · ' + ('channel.health.qualityTab.kpiDeliveryHint' | translate)" />
    <card-graphic-small-legacy-component
      [label]="percentLabel(quality.kpis.readRate)"
      [total]="('channel.health.qualityTab.kpiRead' | translate) + ' · ' + ('channel.health.qualityTab.kpiReadHint' | translate)" />
    <card-graphic-small-legacy-component
      [label]="numberLabel(quality.kpis.sent30d)"
      [total]="('channel.health.qualityTab.kpiSent' | translate) + ' · ' + ('channel.health.qualityTab.kpiSentHint' | translate)" />
    <card-graphic-small-legacy-component
      [label]="numberLabel(quality.kpis.billedVolume30d)"
      [total]="('channel.health.qualityTab.kpiBilled' | translate) + (costLabel() ? ' · ' + ('channel.health.qualityTab.kpiBilledCost' | translate: { cost: costLabel() }) : '')" />
  </div>

  <!-- Templates below High, ordered by sent volume (RF-29) -->
  <div class="card">
    <div class="card-body">
      <h5 class="section-title">{{ 'channel.health.qualityTab.templatesTitle' | translate }}</h5>
      <p class="text-muted small">{{ 'channel.health.qualityTab.templatesSubtitle' | translate }}</p>
      @if (quality.templates.length === 0) {
        <p class="text-muted mb-0">{{ 'channel.health.qualityTab.templatesEmpty' | translate }}</p>
      } @else {
        <div class="table-responsive">
          <table class="table align-middle quality-templates">
            <thead>
              <tr>
                <th>{{ 'channel.health.qualityTab.templatesName' | translate }}</th>
                <th>{{ 'channel.health.qualityTab.templatesCategory' | translate }}</th>
                <th>{{ 'channel.health.qualityTab.templatesQuality' | translate }}</th>
                <th class="text-end">{{ 'channel.health.qualityTab.templatesSent' | translate }}</th>
                <th class="text-end">{{ 'channel.health.qualityTab.templatesReadRate' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (template of quality.templates; track template.id) {
                <tr>
                  <td class="quality-templates__name">{{ template.name }}</td>
                  <td>{{ template.category }}</td>
                  <td><span class="badge campaign-badge" [ngClass]="templateQualityClass(template.quality)">{{ templateQualityLabel(template.quality) }}</span></td>
                  <td class="text-end">{{ numberLabel(template.sent) }}</td>
                  <td class="text-end">{{ percentLabel(template.readRate) }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>

  <!-- Marketing opt-outs signaled by the provider (RF-30) -->
  <div class="card">
    <div class="card-body optout-card">
      <div>
        <h5 class="section-title mb-1">{{ 'channel.health.qualityTab.optOutsTitle' | translate }}</h5>
        <p class="text-muted small mb-0">{{ 'channel.health.qualityTab.optOutsSubtitle' | translate }}</p>
      </div>
      <div class="optout-card__numbers">
        <span class="optout-card__value">{{ numberLabel(quality.optOuts.last30) }}</span>
        <span class="fw-semibold small" [ngClass]="optOutDeltaClass()">{{ optOutDeltaLabel() }}</span>
      </div>
    </div>
  </div>
}
